import { render, staticRenderFns } from "./SignaturesContractor.vue?vue&type=template&id=b8b190a8&scoped=true"
import script from "./SignaturesContractor.vue?vue&type=script&lang=js"
export * from "./SignaturesContractor.vue?vue&type=script&lang=js"
import style0 from "./SignaturesContractor.vue?vue&type=style&index=0&id=b8b190a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b190a8",
  null
  
)

export default component.exports